import { websocketFilterManager } from 'lib/ws/services/websocket-filter-manager'
import { MULTIGET_SUBSCRIPTIONS } from './subscriptions'

export class GRPCSubscriptionMultiGet {
    public static registerMultiGetSubscription(subscriptionKey: string, tag: string, watchInserts: boolean): void {
        if (!MULTIGET_SUBSCRIPTIONS[subscriptionKey]) {
            MULTIGET_SUBSCRIPTIONS[subscriptionKey] = [tag, '']
        }
        websocketFilterManager.setWatchInsertsForSubscription(subscriptionKey, watchInserts)
        websocketFilterManager.onSubscriptionsChanged('normal')
    }

    public static updateMultiGetRefs(subscriptionKey: string, refStrings: string[]): void {
        const subscription = MULTIGET_SUBSCRIPTIONS[subscriptionKey]

        if (!subscription) return

        const refString = refStrings.length > 0 ? refStrings[0] : ''
        subscription[1] = refString

        websocketFilterManager.onSubscriptionsChanged('normal')
    }

    public static setWatchInserts(subscriptionKey: string, enabled: boolean): void {
        websocketFilterManager.setWatchInsertsForSubscription(subscriptionKey, enabled)
    }

    public static unregisterMultiGetSubscription(subscriptionKey: string): void {
        delete MULTIGET_SUBSCRIPTIONS[subscriptionKey]
        websocketFilterManager.onSubscriptionsChanged('normal')
    }
}

export const multiGetSubscriptionManager = GRPCSubscriptionMultiGet
